<div class="search-form-editor p-3">

    <div class="row">
        <div class="col-md-5 col-sm-6 col-12">
            <div class="row align-items-center mb-3">
                <div class="col-auto">
                    <label class="fw-bold">{{ 'Name' | translate }}</label>
                </div>
                <div class="col">
                    <dx-select-box [dataSource]="allSearchForms"
                                   displayExpr="name"
                                   [(value)]="selectedSearchForm"
                                   placeholder="Suche auswählen...">
                    </dx-select-box>
                </div>
                <div class="col-auto d-flex gap-2">
                    <dx-button id="addbutton" icon="plus" type="default" stylingMode="text"
                               (onClick)="openNewRowPopup()"></dx-button>
                    <dx-button id="editbutton" *ngIf="selectedSearchForm" icon="edit" type="default" stylingMode="text"
                               (onClick)="openRenameSearchFormPopup()"></dx-button>
                    <dx-button *ngIf="selectedSearchForm" icon="copy" type="default" stylingMode="text"
                               (onClick)="copySearchForm()"></dx-button>

                    <dx-button *ngIf="selectedSearchForm" icon="trash" type="default" stylingMode="text"
                               (onClick)="deleteSearchForm()"></dx-button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="selectedSearchForm">
        <div class="row mb-4">
            <div class="col-auto">
                <label class="fw-bold">{{ 'Kondition' | translate }}</label>
            </div>
            <div class="col">
                <dx-radio-group [items]="['und', 'oder']"
                                [(value)]="selectedSearchForm.filterCondition"
                                layout="horizontal">
                </dx-radio-group>
            </div>
        </div>

        <div class="condition-grid border-top pt-3">
            <div class="row gx-2 mb-1 text-muted small px-5">
                <div class="col-2">Gruppe</div>
                <div class="col-3">Feld</div>
                <div class="col-2">Operator</div>
                <div class="col">Werte</div>
                <div class="col-auto" style="width: 40px;"></div>
            </div>

            <dx-scroll-view width="100%" height="400px" showScrollbar="onHover">
                <dx-sortable
                    filter=".condition-row"
                    handle=".drag-handle"
                    (onReorder)="onReorderSearchOptions($event)">
                    <ng-container *ngFor="let row of selectedSearchForm?.searchOptions; let i = index; let last = last" >
                        <div class="condition-row d-flex align-items-center gap-2 mb-2 p-2 bg-light rounded shadow-sm">
                            <div class="drag-handle text-muted" style="cursor: grab;">
                                <i class="dx-icon-dragvertical"></i>
                            </div>
                            <div class="row gx-2 flex-grow-1">
                                <div class="col-2">
                                    <dx-select-box [items]="['Produkt', 'Merkmale']"
                                                   [(value)]="row.group"
                                                   (onValueChanged)="saveSearchForm()" 
                                    ></dx-select-box>
                                </div>
                                <div class="col-3">
                                    <dx-select-box [items]="['Feld0', 'Feld1']" (onValueChanged)="saveSearchForm()" [(value)]="row.field"></dx-select-box>
                                </div>
                                <div class="col-2">
                                    <dx-select-box [items]="['ist gleich', 'enthält']"
                                                   (onValueChanged)="saveSearchForm()"
                                                   [(value)]="row.operator"></dx-select-box>
                                </div>
                                <div class="col">
                                    <dx-tag-box [items]="['test1', 'test2', 'test3']"
                                                [(value)]="row.values"
                                                (onValueChanged)="saveSearchForm()"
                                                [showSelectionControls]="true"
                                                stylingMode="filled">
                                    </dx-tag-box>
                                </div>
                            </div>
                            <dx-button icon="trash"
                                       type="default"
                                       stylingMode="text"
                                       (onClick)="removeRow(i)">
                            </dx-button>
                        </div>

                        <div class="my-2">
                            <span class="badge bg-secondary px-3 py-2">
                                {{ selectedSearchForm.filterCondition | translate}}
                            </span>
                        </div>

                    </ng-container>
                </dx-sortable>
            </dx-scroll-view>

            <div class="mt-3, rightside">
                <dx-button icon="plus"
                           stylingMode="contained"
                           (onClick)="addNewRow()">
                </dx-button>
            </div>
        </div>

        <footer class="rightside">
            <dx-button
                stylingMode="contained"
                type="normal"
                text="{{ 'Abbrechen' | translate }}"
                (onClick)="popupClose()"
            ></dx-button>

            <dx-button
                stylingMode="contained"
                type="default"
                text="{{ 'Speichern' | translate }}"
                (onClick)="saveSearchForm()"
            ></dx-button>
        </footer>
    </div>


</div>
<dx-popover
    #addSearchFormPopup
    target="#addbutton"
    position="bottom"
    (onShown)="onPopoverShown()"
    [width]="300"
    [hideOnOutsideClick]="false"
    [(visible)]="createNewSearchFormPopoverVisible">
    <div class="p-2">
        <div class="mb-2 fw-bold text-muted small">
            {{ 'Name des Suchformulars' | translate }}
        </div>

        <div class="d-flex gap-2">
            <dx-text-box
                #nameInput
                [value]="selectedSearchForm?.name"
                placeholder="{{ 'Name eingeben...' | translate }}"
                valueChangeEvent="keyup"
                class="flex-grow-1">
            </dx-text-box>

            <dx-button
                icon="check"
                type="default"
                stylingMode="contained"
                (onClick)="createNewSearchForm(nameInput.value)">
            </dx-button>
        </div>
    </div>
</dx-popover>

<dx-popover
    target="#editbutton"
    position="bottom"
    [width]="300"
    [hideOnOutsideClick]="false"
    [(visible)]="renameSearchFormpopoverVisible">

    <div class="p-2">
        <div class="mb-2 fw-bold text-muted small">
            {{ 'Suchformular umbennen' | translate }}
        </div>

        <div class="d-flex gap-2">
            <dx-text-box
                #renameInput
                [value]="selectedSearchForm?.name"
                placeholder="{{ 'Name eingeben...' | translate }}"
                valueChangeEvent="keyup"
                class="flex-grow-1">
            </dx-text-box>

            <dx-button
                icon="check"
                type="default"
                stylingMode="contained"
                (onClick)="renameSearchForm(renameInput.value)">
            </dx-button>
        </div>
    </div>
</dx-popover>

